module.exports = __webpack_public_path__ + "static/media/minicheck.99526d1f.svg";